'use client';

import { pushToDataLayer } from '@/components/analytics/ga-core';
import { SOURCE_SHOP_NAME_COOKIE_PREFIX } from '@/constants';
import { setCookie } from '@/utils/cookie';
import { useEffect, useRef } from 'react';

function CheckSourceShopName({
  shopName,
  lotteryId,
}: {
  shopName: string;
  lotteryId: number;
}) {
  const checkingRef = useRef(false);
  const cookieKey = `${SOURCE_SHOP_NAME_COOKIE_PREFIX}_${lotteryId}`;
  useEffect(() => {
    if (checkingRef.current) return;
    checkingRef.current = true;
    // GAに送信するためにcookieをセット
    // maxAgeは7日間
    const maxAge = 7 * 24 * 60 * 60; // 7日間
    setCookie(cookieKey, shopName, maxAge);

    //ついでにGA用イベント（campaign_access_lottery_detail）呼び出し
    pushToDataLayer('campaign_access_lottery_detail', {
      shop_name: shopName,
      lottery_id: lotteryId,
    });
  }, []);
  return <></>;
}

export default CheckSourceShopName;
